import { PAYMENT_INSTRUMENT, EMI_TYPE } from 'pages/PaymentsPage/PaymentOptions/constants';
import { PROVIDER } from '../PaymentOptions/constants';
let TRACK_LINK_PROPS = {
    PAGE_NAME: 'prop4',
    PAGE_TYPE: 'prop3'
};
let TRACK_LINK_VALUES = {
    PAGE_NAME: 'Checkout',
    PAGE_TYPE_DEFAULT: 'Checkout:PaymentOptions',
    PAGE_TYPE_ADVANCE: 'Checkout:Advance_PaymentOptions'
};
const TRACK_LINK = {
    PROPS: TRACK_LINK_PROPS,
    VALUES: TRACK_LINK_VALUES
};
/*
 * For Payment options page's tracking events
 * */
let OPTIONS_PAGE_PROPS = {
    WALLET: 'prop15',
    EGV_ADD_CLICKED: 'prop24',
    ADVANCE_PAYMENT_DETAILS_CLICKED: 'prop24',
    EGV_APPLIED_SUCCESS: 'prop7',
    IS_NEW_PAYMENTS: 'prop26',
    DISABLED_PAYMENT_OPTIONS: 'prop29',
    GET_PAYMENT_OPTIONS_API_CALLED: 'prop63',
    DOD_CONFIRMATION_SHOWN: 'prop23',
    COD_SLA_CONFIRMATION_SHOWN: 'prop7',
    COD_SLA_CONFIRMATION_ACCEPTED: 'prop23',
    PAY_LATER_TNC_CLICKED: 'prop26',
    PREFERRED_OPTION_COUNT: 'prop23',
    PBO_WALLET_PREFERRED_STATUS: 'prop69',
    PREFERRED_BANK_CODE: 'prop9',
    PAGE_VIEW: 'eVar101'
};
let OPTIONS_PAGE_VALUES = {
    FLIPKART_MONEY: 'Flipkart Money',
    GIFT_CARD: 'Gift_Card',
    SEPARATOR_1: '_',
    SEPARATOR_2: '§',
    NO_WALLET_COMPONENTS: 'wallet-components-not-available',
    EGV_ADD_CLICKED: 'add_gc_expand',
    ADVANCE_PAYMENT_DETAILS_CLICKED: 'COD_PP_Details_Clicked',
    EGV_APPLIED_SUCCESS: 'gc_add_success',
    IS_NEW_PAYMENTS: 'new_design_v1',
    GET_PAYMENT_OPTIONS_API_CALLED: 'page_open_att',
    DOD_CONFIRMATION_SHOWN: 'DodPm_popup_shown',
    COD_SLA_CONFIRMATION_SHOWN: 'sla_change_popup_shown',
    COD_SLA_CONFIRMATION_ACCEPTED: 'CODPm_confirm',
    PAY_LATER_TNC_CLICKED: 'pay_later_tnc_click',
    IS_PREFERRED_SHOWN: 'preferred_option_shown',
    OFFER_PBO_SHOWN: 'offer_pbo_shown',
    PAYMENT: 'payment_',
    INFO_LINK_KNOW_MORE: '_KnowMore',
    COD_PROCEED_CLICK: 'cod_proceed',
    WRONG_CAPTCHA: '_wrong_captcha',
    RIGHT_CAPTCHA: '_right_captcha',
    PROCEED: 'Proceed',
    OFFER_APPLIED: 'payment_offer_applied',
    OFFER_WIDGET_TNC_CLICK: 'pbo_disc_tnc_click',
    NET_BANKING_POPULAR_BANK: 'payment_nb_popular_banks',
    NET_BANKING_OTHER_BANK: 'payment_nb_dropdown',
    TLS_VERSION_PREFIX: 'TLSversion_',
    TOKEN_VERSION_PREFIX: 'Token_',
    PPQC_OPTIONS: 'PPQC_',
    PPQC_WALLET: 'PPQC_WALLET',
    PPQC_CARD: 'PPQC_CARD',
    PREFERRED_OPTION_COUNTS: 'PREFERRED_',
    PAGE_VIEW_DEFAULT: 'payment_default',
    PAGE_VIEW_ADVANCE_PAYMENT: 'payment_advance',
    ADVANCE_PAYMENT_SHOWN: 'COD_PP_shown',
    COD_ADVANCE_PAY_NOW: 'COD_PP_pm'
};
export var CORPORATE_NB;
(function (CORPORATE_NB) {
    CORPORATE_NB["CNB_SHOWN"] = "Corporate_NB_Shown";
})(CORPORATE_NB || (CORPORATE_NB = {}));
const OPTIONS_PAGE = {
    PROPS: OPTIONS_PAGE_PROPS,
    EVENTS: 'events',
    COINS_REDEEMED_COUNT: 'event392',
    EGV_2FA_REQUIRED: 'event480',
    VALUES: OPTIONS_PAGE_VALUES
};
/*
 * For Saved Card or new card page's events
 * */
let CARD_PROPS = {
    SAVED_CARDS_COUNT: 'prop7',
    SAVED_CARD_OFFER_AVAILABLE: 'prop74',
    BILLING_ADDRESS_REQUIRED: 'prop69',
    CARD_NOT_SUPPORTED: 'prop74',
    OFFER_APPLIED: 'prop75'
};
let CARD_VALUES = {
    SAVED_CARD_OFFER_AVAILABLE: 'saved_card_offer_available',
    BILLING_ADDRESS_REQUIRED: 'payment_Intl_layout_shown',
    CARD_NOT_SUPPORTED: 'card_not_supported',
    OFFER_APPLIED: 'card_offer_applied',
    MORE_INFO_CLICKED: 'more_info_click',
    CARD_NUMBER_ENTERED: 'card_number_entered_correct',
    WRONG_CARD_NUMBER: 'card_number_entered_wrong',
    NEW_CARD_PROCEED: 'card_number_proceed',
    SAVED_CARD_PROCEED: 'proceed',
    CARD_SELECT: 'Card_Select',
    FOR_EMI: '_for_emi',
    GIFT_CARD: 'gift_card'
};
const CARD = {
    PROPS: CARD_PROPS,
    VALUES: CARD_VALUES
};
/*
 * For Proceed/Continue button on Payment options page
 * */
let OPTIONS_PAGE_PROCEED_PROPS = {
    SELECTED_OPTION: 'prop31',
    NEW_SELECTED_OPTION: 'prop24'
};
let OPTIONS_PAGE_PROCEED_VALUES = {
    EGV: 'voucher',
    PURE_WALLET_FLIPKART_MONEY: 'WalletV2Pm_Flipkart Money',
    PURE_WALLET_GIFT_CARD: 'WalletV2Pm_Gift Card',
    PURE_EGV: 'pure_voucher' /* cannot identify this event. */,
    SEPARATOR_1: '_',
    SEPARATOR_2: '§'
};
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.NETBANKING] = 'NetBankingPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.CREDIT_CARD] = 'New_CardPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.CASH_DELIVERY] = 'CodPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.CARD_ON_DELIVERY] = 'DodPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.PHONEPE_WALLET_2] = OPTIONS_PAGE_VALUES.PPQC_WALLET;
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.PHONEPE_UPI] = 'PhonePePm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.GIFT_CARD_WALLET] = 'Gift Card';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.EGV] = 'voucher';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.EMI] = 'EmiPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.UPI] = 'UPIPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.PHONEPE_UPI] = 'UPI_PhonePePm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.UPI_COLLECT] = 'UPI_IDPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.BNPL] = 'PaylaterPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.ADVANZ] = 'PaylaterPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.SAVED_CARD] = 'Saved_CardPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.PREFERRED_NET] = 'Preferred_NetPm';
OPTIONS_PAGE_PROCEED_VALUES[PAYMENT_INSTRUMENT.WALLET] = 'WalletPm';
let OPTIONS_PAGE_PROCEED_PURE_VALUES = {};
OPTIONS_PAGE_PROCEED_PURE_VALUES[PAYMENT_INSTRUMENT.GIFT_CARD_WALLET] = 'WalletV2Pm_Gift Card';
OPTIONS_PAGE_PROCEED_PURE_VALUES[PAYMENT_INSTRUMENT.EGV] = 'pure_voucher';
const OPTIONS_PAGE_PROCEED = {
    PROPS: OPTIONS_PAGE_PROCEED_PROPS,
    VALUES: OPTIONS_PAGE_PROCEED_VALUES,
    PURE_VALUES: OPTIONS_PAGE_PROCEED_PURE_VALUES
};
export function getInstrumentValue(payment_instrument, provider) {
    if (provider === PROVIDER.PHONEPE) {
        switch (payment_instrument) {
            case PAYMENT_INSTRUMENT.PHONEPE_WALLET_2:
                return OPTIONS_PAGE_PROCEED.VALUES[payment_instrument];
            case PAYMENT_INSTRUMENT.SAVED_CARD:
                return OPTIONS_PAGE_VALUES.PPQC_CARD;
            default:
                return null;
        }
    }
    else {
        return OPTIONS_PAGE_PROCEED.VALUES[payment_instrument];
    }
}
const CUSTOM_LINK_PROPS = {
    USER_ACTION: 'prop24',
    USER_ACTION_2: 'prop31',
    PAGE_TYPE: 'prop3',
    PAGE_NAME: 'prop4',
    SELECTION_DETAILS: 'prop9',
    SELECTION_DETAILS_2: 'prop74',
    OFFER_APPLIED: 'prop75',
    SELECTED_OPTION: 'eVar23',
    DISCOUNT: 'prop69',
    EMI_TYPE: 'prop23'
};
/*
 * For Emi options page
 * */
let EMI_OPTIONS_PROPS = {
    TNC_CLICKED: 'prop24',
    OPTION_TYPE_SELECTED: 'prop75',
    OPTION_CODE_SELECTED: 'prop74',
    EMI_BANK_DISABLED: 'prop29',
    ITEM_BREAKUP_CLICKED: 'prop24',
    CHOOSE_THIS_PLAN: 'prop9',
    CHOOSE_ANOTHER_PLAN: 'prop24',
    NO_COST_ITEM_COUNT: 'prop7',
    CART_ITEM_COUNT: 'event108',
    EVENTS: 'events',
    TYPES_OF_EMI_OPTIONS_SHOWN: 'prop69',
    EMI_SAVED_CARD_COUNT: 'prop37'
};
let EMI_OPTIONS_VALUES = {
    TNC_CLICKED: 'emi_know_more_click',
    EMI_BANK_DISABLED: 'disabled',
    ITEM_BREAKUP_CLICKED: 'item_breakup_click',
    CHOOSE_ANOTHER_PLAN: 'EMI_tenure_another_plan_view',
    CHOOSE_THIS_PLAN: 'EMI_options_choose_plan_click',
    EMI_TENURE_SELECTION: 'payment_EMI_tenure',
    EMI_OPTION: 'EMI_options_',
    EMI_OPTIONS_SHOWN: '_shown'
};
EMI_OPTIONS_VALUES[EMI_TYPE.INTEREST] = 'Interest_EMI_box';
EMI_OPTIONS_VALUES[EMI_TYPE.NO_COST] = 'No_cost_EMI_box';
EMI_OPTIONS_VALUES[EMI_TYPE.PRE_APPROVED] = 'Pre_approved_EMI_box';
const EMI_OPTIONS_PAGE = {
    PROPS: EMI_OPTIONS_PROPS,
    VALUES: EMI_OPTIONS_VALUES
};
let OTP_PROPS = {
    OTP_EVENT: 'prop24',
    OTP_ATTEMPTS_LEFT: 'prop7'
};
let OTP_VALUES = {
    OTP_PROMPT_VISIBLE: 'OTP_prompt_visible',
    RESEND_OTP_CLICKED: 'inline_resend_click',
    OTP_FALLBACK_MODE_CLICKED: 'inline_fallback_mode_click',
    OTP_CLICK_HERE_TO_GO_BACK: 'inline_go-back_click',
    OTP_RETRY_NUDGE: 'OTPRetry_nudge'
};
const OTP = {
    PROPS: OTP_PROPS,
    VALUES: OTP_VALUES
};
const UPI_VALUES = {
    FLOW_VERIFY: 'flow_verify',
    SUCCESS: 'success',
    FAILURE: 'failure',
    FAILED: 'Failed',
    WRONG_ID: 'wrong_id',
    GO_BACK: 'Go_back_click'
};
var EMI_ON_SAVED_CARDS;
(function (EMI_ON_SAVED_CARDS) {
    EMI_ON_SAVED_CARDS["PAY_VIA_EMI"] = "SavedCard_emi_promt_EMI_continue";
    EMI_ON_SAVED_CARDS["PAY_VIA_EMI_PM"] = "SavedCard_emi_option_EMIPm";
    EMI_ON_SAVED_CARDS["PAY_FULL"] = "SavedCard_emi_option_SavedCard_continue";
    EMI_ON_SAVED_CARDS["PAY_FULL_PM"] = "SavedCard_emi_option_SavedCardPm";
    EMI_ON_SAVED_CARDS["SUMMARY_SHOWN"] = "SavedCard_emi_option_EMI_confirm";
    EMI_ON_SAVED_CARDS["EMI_OPTION_SHOWN"] = "SavedCard_emi_option_shown";
})(EMI_ON_SAVED_CARDS || (EMI_ON_SAVED_CARDS = {}));
// For mobile Wallets
var MOBILE_WALLET_PROPS;
(function (MOBILE_WALLET_PROPS) {
    MOBILE_WALLET_PROPS["WALLETS_STATUS_WITH_COUNT"] = "prop7";
    MOBILE_WALLET_PROPS["WALLETS_PROP23"] = "prop23";
    MOBILE_WALLET_PROPS["WALLET_EVENT"] = "event582";
})(MOBILE_WALLET_PROPS || (MOBILE_WALLET_PROPS = {}));
const MOBILE_WALLET_VALUES = {
    SEPARATOR: '|',
    WALLET: 'Wallet',
    WALLET_PM: 'Walletpm',
    LINK_NOW: 'LinkNow',
    CLICKED: 'Clicked',
    ERROR: 'ERROR',
    OTP_PAGE: 'OTP_Page',
    LINKED: 'Linked',
    UNLINK: 'UNLINK',
    SUCCESSFUL: 'Successful',
    LINK: 'Link',
    OTP_ERROR: 'OTP_Error',
    BALANCE: 'Balance',
    CONTINUE: 'continue',
    WALLET_SHOWN: 'Wallet_Shown_',
    DETAILS_CLICK: 'Details_Click',
    SUFFICIENT_BALANCE: 'Sufficient_Balance',
    INSUFFICIENT_BALANCE: 'Insufficient_Balance',
    BALANCE_LOAD_FAILED: 'Balance_Load_Failed'
};
export { TRACK_LINK, OPTIONS_PAGE, CARD, OPTIONS_PAGE_PROCEED, CUSTOM_LINK_PROPS, EMI_OPTIONS_PAGE, OTP, EMI_ON_SAVED_CARDS, UPI_VALUES, MOBILE_WALLET_PROPS, MOBILE_WALLET_VALUES };
